const DataTable = require('../util/data-table');

var MealsManage = function(el, opts) {
    this.$el = el instanceof jQuery ? el : $(el);
    this.options = opts || {};
    this.init();
};
MealsManage.prototype = {
    constructor: MealsManage,
    $el: undefined,
    options: undefined,
    currentCategory: undefined,
    dataTable: undefined,
    init: function() {
        var self = this;

        var $selection = self.$el.find('.meals-select');
        $selection.on('change', function() {
            self.updateCategory();
        });
        if ($selection.val()) {
            self.updateCategory();
        }

        var $addBtn = self.$el.find('.add-btn');
        $addBtn.attr('data-href', $addBtn.attr('href'));
        $addBtn.on('click', function(evt) {
            self.handleAddButton($(evt.currentTarget));
        });


        window.mealsManageQueryParams = function(params) { return self.queryParams(params); };

        self.$el.find('table').on('click', 'tbody a.delete-btn', function(evt) {
            evt.preventDefault();
            self.handleDeleteButton($(evt.currentTarget));
            return false;
        });

        $('#standard-modal').on('click', 'a.delete-btn', function(evt) {
            evt.preventDefault();
            self.requestDeleteButton($(evt.currentTarget));
            return false;
        });

        self.initTable();
    },
    initTable: function() {
        var self = this;
        self.dataTable = new DataTable(self.$el.find('table'), {
            height: true
        });
    },
    queryParams: function(params) {
        params.category = this.currentCategory;
        return params;
    },
    updateCategory: function() {
        var self = this;
        self.currentCategory = self.$el.find('.meals-select').val();
        self.$el.find('table').bootstrapTable('refresh');
    },
    handleAddButton: function($btn) {
        var self = this,
            category = self.$el.find('.meals-select').val();
        if (category) {
            $btn.attr('href', $btn.attr('data-href') + '?category=' + category);
        }
        else {
            $btn.attr('href', $btn.attr('data-href'));
        }
    },
    handleDeleteButton: function($link) {
        var self = this,
            href = $link.attr('href');
        $.get(href).done(function(response) {
            var $modal = $('#standard-modal');
            $modal.find('.modal-header h5').html('Delete Meal');
            $modal.find('.modal-body').html(response);
            $modal.find('.modal-footer').html(
                '<a href="' + href + '" class="btn btn-danger delete-btn">Delete</a>\
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>'
            );
            var instance = bootstrap.Modal.getOrCreateInstance('#standard-modal');
            instance.show();
        });
    },
    requestDeleteButton: function($link) {
        var self = this,
            href = $link.attr('href');
        $.post(href + '?delete=true', {
            '_token': $link.closest('.modal-content').find('input[type=hidden]').val()
        }).done(function(response) {
            if (response.success) {
                self.dataTable.$el.bootstrapTable('refresh');
                var instance = bootstrap.Modal.getOrCreateInstance('#standard-modal');
                instance.hide();
            }
        });
    }
};

module.exports = MealsManage;